import React from "react";
import ButtonGroup from "./ButtonGroup";
/**
 * Number of buttons in a node: one level of fragments is flattened, and a ButtonGroup counts as
 * its buttons (so a group, a split button among them, goes in the ⋯ sheet)
 */
export const countButtons = (node) => React.Children.toArray(node)
    .reduce((n, child) => {
    if (!React.isValidElement(child))
        return n + 1;
    if (child.type === React.Fragment)
        return n + countButtons(child.props.children);
    if (child.type === ButtonGroup)
        return n + Math.max(1, (child.props.buttons || []).length);
    return n + 1;
}, 0);
